import { type PropsWithChildren } from "react";
import { InformationalTooltip } from "../../../../../../../Common/Tooltip";
import { Title } from "../../../../../../../Common/Typography";
import {
  FormSection,
  FormSectionTitleWrapper,
} from "../../__styles__/SidebarColumn";

type DefaultValuesSectionProps = PropsWithChildren<{
  showTooltip?: boolean;
}>;

export function DefaultValuesSection({
  children,
  showTooltip = false,
}: DefaultValuesSectionProps) {
  return (
    <FormSection>
      <FormSectionTitleWrapper>
        <Title size="small" type="semiBold">
          Default value
          {showTooltip && (
            <InformationalTooltip tooltipText="If both static and dynamic default values are set, the dynamic default value will be used." />
          )}
        </Title>
      </FormSectionTitleWrapper>
      {children}
    </FormSection>
  );
}
